import React from "react";
import "./Welcome.css";
import { useNavigate } from "react-router-dom";

export default function Welcome() {
  const navigate = useNavigate();

  const startTest = () => {
    navigate("/goals");
  };
  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <h2 className="welcomeHeading">
          به <span>REDROSE</span> خوش آمدید
        </h2>
        <p className="welcomeText">
          لطفا به چند سوال پاسخ دهید تا اپلیکیشن با توجه به نیاز های شما تنظیم
          شود!
        </p>
        <div className="welcomBtnWrapper">
          <button className="nextQuestion" onClick={startTest}>
            شروع
          </button>
        </div>
      </div>
    </div>
  );
}
